import { useRef, useCallback } from 'react'
import { Text, Flex, useModal, IconButton, PencilIcon } from 'vvs-uikit'
import { GetGotchiOwnerDocument, useUpdateMoleMutation } from 'vvs-gotchi-graphql'
import { useTranslation } from 'contexts/Localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { Mole } from 'state/vvsgotchi/models'
import { useGotchiAuth } from 'state/vvsgotchi/hooks/useAuth'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import { useTheme } from 'styled-components'
import { RenameModal } from './RenameModel'

const NameYourMole: React.FC<{
  mole: Mole
}> = ({ mole }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { account } = useActiveWeb3React()
  const { refresh } = useGotchiOwner()
  const [, ensureAuth] = useGotchiAuth()

  const [updateMole, { data, reset, loading: renameLoading }] = useUpdateMoleMutation()
  const updateMoleErrorRef = useRef(data?.updateMole?.errors)

  updateMoleErrorRef.current = data?.updateMole?.errors
  const handleRename = useCallback(
    async (value: string) => {
      await ensureAuth()
      await updateMole({
        variables: {
          owner: account,
          tokenId: mole.tokenId,
          name: value,
        },
        refetchQueries: [GetGotchiOwnerDocument],
      })
    },
    [updateMole, mole, ensureAuth, account],
  )

  const [openRenameModal] = useModal(
    <RenameModal
      mole={mole}
      onActionClick={handleRename}
      renameErrors={data?.updateMole?.errors}
      reset={reset}
      renameErrorsRef={updateMoleErrorRef}
      loading={renameLoading}
      refresh={refresh}
    />,
    false,
    true,
    'vvsgotchiRename',
  )

  return (
    <Flex gap="4px">
      <Text fontSize="13px" bold color="primaryLight">
        {t('Name your Mole')}
      </Text>
      <IconButton variant="text" onClick={openRenameModal} scale="xs">
        <PencilIcon width="13px" fill={theme.colors.primaryLight} />
      </IconButton>
    </Flex>
  )
}

export default NameYourMole
